import classNames from 'classnames'
import React from 'react'

import BackDrop from '@/shared/components/BackDrop'
import Portal from '@/shared/components/Portal'
import useOutsideClick from '@/shared/hooks/useOutsideClick'

type ModalProps = {
  title?: React.ReactNode //타이틀 컴포넌트
  children: React.ReactNode //컨텐츠 영역
  isOpen: boolean //Modal open 여부
  onClose: () => void //Modal 닫기
  className?: React.ComponentProps<'div'>['className'] //custom style
  footer?: React.ReactNode //하단 footer
  targetId: string
}

const Modal = ({ isOpen, title, children, onClose, className, footer, targetId = '#layer2' }: ModalProps) => {
  const ref = useOutsideClick(onClose)
  if (!isOpen) return null
  return (
    <Portal targetId={targetId}>
      <div>
        <BackDrop isOpen={isOpen} />
        <div ref={ref} className={`modal-container`}>
          <div className={classNames(`modal ${className || ''}`)}>
            {title}
            {children}
            {footer}
          </div>
        </div>
      </div>
    </Portal>
  )
}

export default Modal
